/**
 * Meta Pixel Code.
 * No hay acceso a public/index.html en este proyecto, así que el script oficial
 * de Meta se inyecta en <head> al cargar la página (mismo comportamiento).
 */

export const META_PIXEL_ID = '1097777642591778'

type PixelWindow = Window & {
  fbq?: ((...args: unknown[]) => void) & {
    callMethod?: (...args: unknown[]) => void
    queue?: unknown[]
    push?: unknown
    loaded?: boolean
    version?: string
  }
  _fbq?: unknown
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  const w = window as PixelWindow

  if (!w.fbq) {
    const n: PixelWindow['fbq'] = function (...args: unknown[]) {
      n?.callMethod ? n.callMethod.apply(n, args) : n?.queue?.push(args)
    } as NonNullable<PixelWindow['fbq']>

    w.fbq = n
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  w.fbq?.('init', META_PIXEL_ID)
  w.fbq?.('track', 'PageView')

  // <noscript> fallback del código original de Meta
  if (!document.getElementById('meta-pixel-noscript')) {
    const noscript = document.createElement('noscript')
    noscript.id = 'meta-pixel-noscript'
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`
    document.head.appendChild(noscript)
  }
}
